import { createAction } from '@reduxjs/toolkit';
export const GENERATE_ANALYTIC_TEAM_REPORT = 'GENERATE_ANALYTIC_TEAM_REPORT';
export const generateAnalyticTeamReportAction = createAction(GENERATE_ANALYTIC_TEAM_REPORT);